import {
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID
} from 'graphql'

export interface InvalidCustomFieldType {
  readonly id: string
  readonly validationType: string
}

export const invalidCustomFieldType = new GraphQLObjectType({
  name: 'InvalidCustomFieldType',
  description:
    'Information about a specific custom metadata field that is currently invalid.',
  fields: () => ({
    id: {
      description: 'The ID for the field that is invalid',
      type: new GraphQLNonNull(GraphQLID)
    },
    validationType: {
      description: 'The type of validation that this field is failing',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
